import styled, {css} from "styled-components";
import {EmblaSlide} from "../../components/embla-slider";

export const TariffsBlockSwitcher = styled.div`
  @media (max-width: 1300px){
    display: none;
  }
`;

export const TariffsBlockSwitcherButtons = styled.div`
  margin-bottom: 30px;
  display: flex;

  @media (min-width: 1301px){
    display: none;
  }
  @media (max-width: 650px){
    margin-bottom: 0;
  }

  button {
    font-weight: 600;
    font-size: 18px;
    line-height: 22px;
    margin-right: 20px;
    padding: 10px 22px 8px;
    &:last-child {
      margin-right: 0;
    }

    @media (max-width: 650px){
      padding: 12px 22px 9px;
      font-size: 16px;
      line-height: 19px;
      margin-right: 8px;
    }
  }
`;

export const TariffsBlockSettingsIcon = styled.div`
  line-height: 0;
  cursor: pointer;
  display: none;

  @media (max-width: 650px){
    display: block;
    margin-right: 20px;
  }
  @media (max-width: 425px){
    margin-right: 13px;
  }

  ${({show}) => show && css`
    svg path {
      fill: #FFCD00;
    }
  `}
`;

export const TariffsBlockSelectButtons = styled.div`
  margin-top: 17px;
  width: 100%;
  display: none;
  
  @media (max-width: 650px){
    display: block;
  }

  button {
    padding: 0 13px;
    height: 44px;
    display: flex;
    align-items: center;
    line-height: 0;
  }

  ${EmblaSlide} {
    margin-right: 40px;

    @media (max-width: 1440px){
      margin-right: 30px;
    }
    @media (max-width: 1024px){
      margin-right: 20px;
    }
    @media (max-width: 425px){
      margin-right: 8px;
    }
  }
`
